import { orchestrator } from 'satcheljs';
import { updateNumDaysInDayRange } from '../actions/updateNumDaysInDayRange';
import { updateNumDaysInDayRangeServerValue } from '../utils/updateFlexibleDayViewValues';
import { resetNumDaysInDayRange } from '../actions/resetNumDaysInDayRange';

orchestrator(updateNumDaysInDayRange, actionMessage => {
    const { newValue } = actionMessage;
    updateNumDaysInDayRangeServerValue(newValue);
});

orchestrator(resetNumDaysInDayRange, actionMessage => {
    updateNumDaysInDayRangeServerValue(1);
});
